import React, { useEffect, useState } from 'react';
import {
    Box, Table, TableHead, TableBody, TableRow, TableCell, Paper, Typography
} from "@mui/material";
import axiosInstance from '../../../../lib/axios';
import { toast } from 'react-toastify';

const RecipeFood = ({ onSelectFood, searchText }) => {
    const [food, setFood] = useState([]);
    const [filteredFood, setFilteredFood] = useState([]);

    useEffect(() => {
        fetchFoodData();
    }, []);

    useEffect(() => {
        if (!searchText.trim()) {
            setFilteredFood(food);
            return
        }

        const lowerSearch = searchText.toLowerCase().trim();

        const filtered = food.filter((row) =>
            (row.FoodName?.toLowerCase() || '').includes(lowerSearch) ||
            (row.FoodGrpName?.toLowerCase() || '').includes(lowerSearch) ||
            (row.FoodSubGrpName?.toLowerCase() || '').includes(lowerSearch) ||
            (row.FoodClsName?.toLowerCase() || '').includes(lowerSearch) ||
            (row.UnitName?.toLowerCase() || '').includes(lowerSearch) ||
            (row.Price?.toString() || '').includes(lowerSearch) ||
            (row.SplPrice?.toString() || '').includes(lowerSearch)
        );

        setFilteredFood(filtered);
    }, [searchText, food])

    const fetchFoodData = async () => {
        try {
            const response = await axiosInstance.post("MstFood/GetMstFoodDashBoard", {
                start: 1,
                PageSize: 1,
                SearchText: ""
            });
            if (response.data.Status === 0) {
                setFood(response.data.Data);
                setFilteredFood(response.data.Data);
            } else {
                setFood([]);
            }
        } catch (error) {
            toast.error("Error while fetching the data.");
        }
    };

    const handleRowdoubleClick = (row) => {
        if (onSelectFood) {
            onSelectFood(row);
        }
    };

    return (
        <Box sx={{ padding: 2 }}>
            <Paper sx={{ width: '100%', overflowX: 'auto', boxShadow: 3, borderRadius: 2 }}>
                <Table sx={{ minWidth: 650, borderCollapse: 'separate', borderSpacing: '0 8px' }}>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#635bff' }}>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold', py: 0.5, px: 1.5, fontSize: '0.8rem' }}>
                                Food Name
                            </TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold', py: 0.5, px: 1.5, fontSize: '0.8rem' }}>
                                Food Group
                            </TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold', py: 0.5, px: 1.5, fontSize: '0.8rem' }}>
                                Food Sub Group
                            </TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold', py: 0.5, px: 1.5, fontSize: '0.8rem' }}>
                                Food Class
                            </TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold', py: 0.5, px: 1.5, fontSize: '0.8rem' }}>
                                Price
                            </TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold', py: 0.5, px: 1.5, fontSize: '0.8rem' }}>
                                Unit
                            </TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold', py: 0.5, px: 1.5, fontSize: '0.8rem' }}>
                                Special Price
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredFood.length > 0 ? (
                            filteredFood.map((row, idx) => (
                                <TableRow
                                    key={row.FoodId}
                                    hover
                                    onDoubleClick={() => handleRowdoubleClick(row)}
                                    sx={{
                                        backgroundColor: idx % 2 === 0 ? '#f9f9f9' : 'transparent',
                                        '&:hover': { backgroundColor: '#f1f1f1', cursor: 'pointer' },
                                        cursor: 'pointer'
                                    }}
                                >
                                    <TableCell sx={{ py: 0, px: 1.5, fontSize: '0.8rem' }}>{row.FoodName}</TableCell>
                                    <TableCell sx={{ py: 0, px: 1.5, fontSize: '0.8rem' }}>{row.FoodGrpName}</TableCell>
                                    <TableCell sx={{ py: 0, px: 1.5, fontSize: '0.8rem' }}>{row.FoodSubGrpName}</TableCell>
                                    <TableCell sx={{ py: 0, px: 1.5, fontSize: '0.8rem' }}>{row.FoodClsName}</TableCell>
                                    <TableCell sx={{ py: 0, px: 1.5, fontSize: '0.8rem' }}>{row.Price}</TableCell>
                                    <TableCell sx={{ py: 0, px: 1.5, fontSize: '0.8rem' }}>{row.UnitName}</TableCell>
                                    <TableCell sx={{ py: 0, px: 1.5, fontSize: '0.8rem' }}>{row.SplPrice}</TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={7} align="center">
                                    <Typography>No matching food found</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </Paper>
        </Box>
    );
};

export default RecipeFood;